module.exports = __webpack_public_path__ + "img/imgaudio-off.ef1c274f.png";